<template>
  <div class="navbar-container d-flex content align-items-center justify-content-between">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center d-none d-lg-flex">
      <dark-Toggler class="d-none d-lg-block" />
    </div>

    <customer-select v-if="isDeveloper || $store.state.user.customers.length>1" />
    <h3 v-else-if="isAdmin || isFenomen">{{ $store.state.user.customerInfo ? $store.state.user.customerInfo.domain : '' }}</h3>
    
    <b-button v-if="isDeveloper"
      variant="danger"
      class="ml-1"
      @click="clearCache"
    >
      <feather-icon icon="Trash2Icon" size="16" />
      Cache Temizle
    </b-button>

    <b-navbar-nav class="nav align-items-center" >
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0" v-if="userData">
              {{ userData.name_surname }}
            </p>
            <span class="user-status">
              <span v-if="isAdmin">Marka Yöneticisi</span>
              <span v-else-if="isDeveloper">Developer</span>
              <span v-else-if="isFenomen">Fenomen</span>
              <span v-else-if="userData.role=='sales_team'">Satış Ekibi</span>
              <span v-else>Unknown User</span>
            </span>
          </div>
          <!--
          <b-avatar
            size="40"
            variant="light-primary"
            badge
            :src="require('@/assets/images/avatars/13-small.png')"
            class="badge-minimal"
            badge-variant="success"
          />-->
        </template>

        <b-dropdown-item v-if="userData" :to="{ name: isAdmin ? 'admin-detail' : 'influencer-detail', params: { id: userData.id } }" link-class="d-flex align-items-center">
          <feather-icon
            size="16"
            icon="UserIcon"
            class="mr-50"
          />
          <span>Profil</span>
        </b-dropdown-item>

        <b-dropdown-divider />

        <b-dropdown-item link-class="d-flex align-items-center"
        @click="logout">
          <feather-icon
            size="16"
            icon="LogOutIcon"
            class="mr-50"
          />
          <span>Çıkış Yap</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav, BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar,
  BButton,
} from 'bootstrap-vue'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import CustomerSelect from '@/components/manage/CustomerSelect'

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    CustomerSelect,
    BButton,

    // Navbar Components
    DarkToggler,
  },
  data() {
    return {
    }
  },
  computed: {
    userData() {
      return this.$store.state.user.userData;
    }
  },
  methods: {
    logout() {
      // Remove userData from localStorage
      this.$store.commit('user/LOGOUT_USER')
      this.$router.replace({ name: 'login' });
    },
    clearCache() {
      this.$http.get('/manage/clear-cache')
        .then((response) => {
          console.log("response")
          if(response.data.success){
            this.$toast.success('Cache temizlendi!');
          }else{            
            this.$toast.error('Cache temizlemede hata.');
          }
        })
        .catch(() => {
          this.$toast.error('Cache temizlemede hata.');
        });
    },  
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
}
</script>
